import { showSuccessAlert } from "@actions/index";
import { connect } from "react-redux";
import BaseBreakdownTab from "./BaseBreakdowTab";

class CollectionPeriod extends BaseBreakdownTab {
  meterGridKey = "meterGrid";
  detailGridKey = "detailGrid";
}

const mapStateToProps = (state) => {
  return {
    modal: state.collectionBreakdownModal,
  };
};

export default connect(mapStateToProps, { showSuccessAlert })(CollectionPeriod);
